<template>
  <div class="error404">
    <h1>Erreur 404</h1>
    Page inexistante :(
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.error404 {
  padding: 10px;
}
</style>
